<div header="Archive Project" class="align-items-center">
    <h5 class="block mb-5">This is an unpublished project. Do you want to archive it?</h5>
    <div class="flex align-items-center gap-3 mb-3">
        <textarea [(ngModel)]="endMessage" rows="3" cols="30" pInputTextarea id="end-reason" class="flex-auto pt-3 pl-2" autocomplete="off" placeholder="Message to be shared with staff on notification of project completion.(optional)"></textarea>
    </div>

    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" size="large"
            [rounded]="true"
            [outlined]="true" (click)="closeDialog()" />
        <p-button label="Archive" [rounded]="true" size="large" (click)="archive(endMessage)" />
    </div>
</div>
